import { useContext } from "react";

import { useAdminFramerateProfilesApi } from "../../../api/useAdminFramerateProfilesApi";
import { FramerateProfileListingContext } from "../../../context/FramerateProfilesListingContext";
import { CreateFramerateProfileFormInputs } from "./CreateFramerateProfileForm";

export const useCreateFramerateProfileForm = () => {
    const { createFramerateProfile: createProfile } = useAdminFramerateProfilesApi();
    const { add: addFramerateProfileToContext } = useContext(FramerateProfileListingContext);
    const createFramerateProfile = async (inputs: CreateFramerateProfileFormInputs) => {
        const name = inputs.name;
        const mappings = {
            23.98: inputs.framerate2398,
            29.97: inputs.framerate2997,
            24: inputs.framerate24,
            25: inputs.framerate25,
            30: inputs.framerate30,
            50: inputs.framerate50,
            59.94: inputs.framerate5994,
            60: inputs.framerate60,
            OTHER: inputs.framerateOther
        };
        const response = await createProfile({
            name,
            framerate2398: inputs.framerate2398,
            framerate2997: inputs.framerate2997,
            framerate24: inputs.framerate24,
            framerate25: inputs.framerate25,
            framerate30: inputs.framerate30,
            framerate50: inputs.framerate50,
            framerate60: inputs.framerate60,
            framerate5994: inputs.framerate5994,
            framerateOther: inputs.framerateOther
        });

        addFramerateProfileToContext({
            id: response.entityId,
            name,
            mappings,
            updatedDate: new Date()
        });
    };

    return {
        createFramerateProfile
    };
};
